import axios from 'axios'
import {_} from 'underscore'

export const state = () => ({
  DBTaxons: [],
  DBTaxonsObj: {},
  DBRanks: {
    "phylum":{},
    "class":{},
    "order":{},
    "family":{},
    "genus":{},
    "species":{}
  }
})

export const getters = {

}

export const mutations = {

  loadTaxons(state,datas){

    state.DBTaxons = datas;

    state.DBTaxonsObj = {}
    _.each(state.DBTaxons, function (objTaxon){
      state.DBTaxonsObj[objTaxon.taxon_id] = objTaxon
    })
  },

}

export const actions = {

}


// WEBPACK FOOTER //
// ./store/database.js